export const UrlPath = path => {
	if(path.substring(0, 2) === '/.') path = path.substring(2)
	return path
}

export const pageDescription = description => {
	if(description === null) return
	const regex = /(<([^>]+)>)/ig
	const cleanDescription = description && description.replace(regex, '')
	const metaDescription = cleanDescription.split(" ").splice(0,20).join(" ") + '...'
	return metaDescription
}